import React, {Component} from 'react';
import {Icon} from 'antd';
import './style.css'
import { whileStatement } from '@babel/types';
export default class ExampleCss extends Component {
	constructor(props){
	  super(props);
	  this.wrapperRef =React.createRef();
	}
	handleClick(){
	const wrapper = this.wrapperRef.current;
	wrapper.classList.toggle('is-nav-open')
	}
render(){
  return(
  <div ref={this.wrapperRef}  className="wrapper">
      <div className="nav">
   <Icon className="nav__icon"
         type="menu-fold"
         onClick={() => this.handleClick()}
     />
    <div className="nav__body">

    <i class="video icon">
              <a style={{margin: '8px',color:'#DE5C1F',fontSize:'14px'}} href="https://mountzionfirm-lcqswpqyat.now.sh/signin">Live TV</a>
              </i>
       </div>
       <i className="upload icon"></i>
   </div>

</div>
);
}
  }
